import React from 'react';
import { TRUST_BAR_ITEMS } from '../data/seoLandingPages';

const TrustBar = ({ variant = 'full', items = TRUST_BAR_ITEMS }) => {
  if (variant === 'compact') {
    return (
      <div className="mx-auto flex flex-col gap-2">
        {items.map((item) => (
          <div
            key={item}
            className="flex items-center rounded-xl border border-gray-200 bg-white px-4 py-3 text-xs font-medium text-gray-700 shadow-sm whitespace-nowrap"
          >
            {item}
          </div>
        ))}
      </div>
    );
  }

  const gridClassName =
    variant === 'two-column'
      ? 'mx-auto grid gap-3 grid-cols-2'
      : 'mx-auto grid max-w-6xl gap-3 sm:grid-cols-2 xl:grid-cols-4';

  return (
    <div className={gridClassName}>
      {items.map((item) => (
        <div
          key={item}
          className="rounded-2xl border border-gray-200 bg-white px-5 py-4 text-sm font-medium text-gray-700 shadow-sm"
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default TrustBar;
